import { StyledContextIconButton } from '../styled'
import { Box, Typography } from '@material-ui/core'
import { useTheme } from 'styled-components'

interface IContextMenuButton {
    text: string
    [rest: string]: any
    margin?: string
    icon?: any
}

export const ContextMenuButton = ({ text, margin, icon, ...rest }: IContextMenuButton) => {
    const theme = useTheme()

    return (
        <StyledContextIconButton
            size="small"
            {...rest}
        >
            <Box m={margin || ''} display="flex" flexDirection="row" alignItems="center">
                {icon}
                <Typography component="span" variant="subtitle2">
                    <Box color={theme.colors.accent1} m="0 0.5em">
                        {text}
                    </Box>
                </Typography>
            </Box>
        </StyledContextIconButton>
    )
}
